import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'
import AppLayout   from '../components/layout/AppLayout'
import LoginPage   from '../pages/auth/LoginPage'
import AuditDashboardPage from '../pages/audit/AuditDashboardPage'
import RunAuditPage       from '../pages/audit/RunAuditPage'
import NotFoundPage       from '../pages/NotFoundPage'
import RunRegressionPage from '../pages/Regression/RunRegressionPage'
import HubPage from '../pages/hub/HubPage'

/**
 * ProtectedRoute — redirects to /login if user is not authenticated.
 * Wrap any route that requires auth.
 */
function ProtectedRoute({ allowedRoles }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const role = useAuthStore((s) => s.user?.role)

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (
    allowedRoles &&
    !allowedRoles.includes(role)
  ) {

    if (role === 'POLICY_AUDIT_USER')
      return <Navigate to="/audit/run" replace />

    if (role === 'REGRESSION_RUNNER')
      return <Navigate to="/regression/run" replace />

    if (role === 'ADMIN')
      return <Navigate to="/audit/run" replace />
  }

  return <Outlet />
}

function RoleRoute({ allowedRoles, children }) {
  const role = useAuthStore((s) => s.user?.role)

  if (!allowedRoles.includes(role)) {
    if (role === 'POLICY_AUDIT_USER') {
      return <Navigate to="/audit/run" replace />
    }

    if (role === 'REGRESSION_RUNNER') {
      return <Navigate to="/regression/run" replace />
    }

    return <Navigate to="/" replace />
  }

  return children
}

/**
 * Prevents logged-in users from accessing the login page.
 */
function GuestRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const role = useAuthStore((s) => s.user?.role)

  if (isAuthenticated) {
    if (role === 'REGRESSION_RUNNER') {
      return <Navigate to="/regression/run" replace />
    }

    return <Navigate to="/audit/run" replace />
  }

  return <Outlet />
}


export const router = createBrowserRouter([
  // Public landing page – Bridger Application Hub (no authentication)
  { path: '/', element: <HubPage /> },

  // Guest-only routes (login)
  {
    element: <GuestRoute />,
    children: [
      { path: '/login', element: <LoginPage /> },
    ],
  },

  // Protected routes (requires auth)
// ADMIN + POLICY_AUDIT_USER
{
  element: <ProtectedRoute />,
  children: [
    {
      element: <AppLayout />,
      children: [
        {
          path: '/audit/run',
          element: (
            <RoleRoute allowedRoles={[ 'ADMIN', 'POLICY_AUDIT_USER',]}>
            <RunAuditPage />
            </RoleRoute>
          ),
        },

        {
          path: '/regression/run',
          element: (
            <RoleRoute allowedRoles={[ 'ADMIN','REGRESSION_RUNNER',]}>
            <RunRegressionPage />
            </RoleRoute>
          ),
        },

        // Future routes
        // {
        //   path: '/claims/run',
        //   element: (
        //     <RoleRoute allowedRoles={['ADMIN', 'CLAIMS_USER']}>
        //       <ClaimsRunPage />
        //     </RoleRoute>
        //   ),
        // },
      ],
    },
  ],
},
  // 404
  { path: '*', element: <NotFoundPage /> },
])
